import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import {  Card, Dropdown, Row, Col } from 'react-bootstrap';
import Radio from '@material-ui/core/Radio';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { analytics, logEvent } from '~/services/firebaseConfig';

import { Container, CardOrder, MainContainer } from '~/components/layout/Logistic/styles';
import {
  TitlePage as IconsTop,
  CloseIconStyled as IconStyled,
  Title,
  InputQuantity,
  TextQuantity,
  SelectProduct,
  IconProductStyles,
  CardHeader,
  ContainerButton,
  AlignProducts,
  AlignDropdownBranch,
  ButtonDivision,
  LoadingIcon,
  Product,
  Quantity,
  QuantityIcon,
  ButtonOutline
} from './styles';
import { Creators } from "~/store/ducks/logistic";
import close from '~/assets/images/close.png';
import '~/components/styles/Global.css';
import IconProduct from '~/components/layout/IconProduct';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import api from '~/services/api';
import { InfoButton, InfoButtonDisabled } from '~/components/layout/Buttons';
import OrderType from '~/components/pages/Logistic/OrderType';
import ObservationComponent from '~/components/pages/Logistic/Observation';
import Loading from '~/components/layout/Loading';
import OpenChatBot from '~/components/layout/Chatbot';
import Stepper from '~/components/layout/Logistic/StepperLine';
import RedirectToPortal from '~/components/layout/Logistic/RedirectToPortal';
import { hasNumberInString, replaceNumberInString, extractDateFromMessage, reformatDateString } from '~/utils/utils';
import ModalCountdown from '~/components/layout/Logistic/ModalCountdown';



const mapperServiceType = {
  RETIRA: 'RETIRA',
  ENTREGA: 'ENTREGA'
}

export default function InitialOrder() {
  const dispatch = useDispatch();
  const history = useHistory();

  const roles = useSelector(state => state.rolesReducer.roles);
  const logisticReducer = useSelector(state => state.logisticReducer);
  const itemsReducer = useSelector(state => state.logisticReducer.items);
  const observation = useSelector(state => state.logisticReducer.observation);
  const date = useSelector(state => state.logisticReducer.date);

  const [loadingPage, setLoadingPage] = useState(true);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [loadingItems, setLoadingItems] = useState(false);
  const [shippingMode, setShippingMode] = useState('');
  const [expand, setExpand] = useState(false);
  const [branches, setBranches] = useState([]);
  const [desktopObservation, setDesktopObservation] = useState(false);
  const [servicesTypes, setServicesTypes] = useState([]);
  const [deliveryType, setDeliveryType] = useState(logisticReducer.deliveryType ? logisticReducer.deliveryType : 0)
  const [mode, setMode] = useState({ mode: 'edit', index: 0 });
  const [itemsAll, setItemsAll] = useState(itemsReducer ? itemsReducer : [] );
  const [loadBusiness, setLoadBusiness] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(0);
  const [productIndex, setProductIndex] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [modalCancel, setModalCancel] = useState(false);
  const [isPriceListOk, setIsPriceListOk] = useState(false);
  const [modalCountdown, setModalCountdown] = useState(false);



  useEffect(() => {
    const handleLoad = () => {
      dispatch({ type: "SET_STEP_ACTIVE", stepActive: 0 });
      dispatch({ type: "SET_ORDER_DRAFT", orderDraft: { loadedPage: true } });
    };
    window.addEventListener('load', handleLoad);
    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, []);

  useEffect(() => {
    setLoadingItems(true);
    if (logisticReducer?.orderDraft?.applied && logisticReducer?.orderDraft?.data && loadBusiness && itemsAll.length === 0) {
      const newItem = { product: null, quantity: null };
      const newItems = [...logisticReducer.orderDraft.data, newItem];
      const cleaned = cleanItems(newItems);
      setMode({ mode: 'edit', index: cleaned.length -1 });
      setQuantity(0);
      setProductIndex(0);
      setItemsAll(cleaned);
    }
    setLoadingItems(false);
  }, [loadBusiness]);

  const cleanItems = (items) => {
    let nullNullItemFound = false;
    for (let i = items.length - 1; i >= 0; i--) {
      const item = items[i];
      const product = item.product;
      const quantity = item.quantity;

      if (product === null && quantity === null && !nullNullItemFound) {
        nullNullItemFound = true;
      } else if (product === null && (quantity === null || quantity === 0)) {
        items.splice(i, 1);
      }
    }
    return items;
  }

  useEffect(() => {

    if(itemsAll.length === 0) {
      const initialItem = { product: null, quantity: null };
      setItemsAll([initialItem]);
      setMode({ mode: 'edit', index: 0 });
      setQuantity(0);
    } else {
      setMode({ mode: 'view', index: itemsAll.length });
      setQuantity(itemsAll.length);
    }
  }, []);

  useEffect(() => {
    dispatch({ type: "SET_DELIVERY_TYPE", deliveryType: deliveryType });
  }, [deliveryType]);

  useEffect(() => {
    const uniqueItems = itemsAll.reduce((acc, curr) => {
      const existingItem = acc.find(item => item.product && curr.product && item.product.code === curr.product.code);
      if (existingItem) {
        existingItem.quantity += curr.quantity;
      } else {
        acc.push(curr);
      }
      return acc;
    }, []);

    if (uniqueItems && uniqueItems.length !== itemsAll.length) {
      setItemsAll(uniqueItems);
    }
  }, [itemsAll]);

  const handleAddItem = () => {
    if (!itemsAll.find((item) => item.quantity === null || item.quantity === 0)) {
      const newItem = { product: null, quantity: null };
      setQuantity(0);
      setProductIndex(0);
      setItemsAll(prevItems => [...prevItems, newItem]);
      setMode({ mode: 'edit', index: itemsAll.length });
    }
  };

  const handleEditItem = (selectedIndex) => {
    const selectedItem = itemsAll[selectedIndex];
    const productIndexInBranch = branches[
      selectedBranch ? selectedBranch : 0
    ].products.findIndex(product => product.code === selectedItem.product.code);
    setProductIndex(productIndexInBranch);
    setQuantity(selectedItem.quantity);
    setMode({ mode: 'edit', index: selectedIndex });
  };


  const handleDeleteItem = index => {
    if (itemsAll.length > 1) {
      const newIndex = findIndexWithNullPropertyExcluding(itemsAll, index);
      if (newIndex || newIndex === 0) {
        setMode({ mode: 'edit', index: newIndex });
      }
    }
    setItemsAll(prevItems => prevItems.filter((_, i) => i !== index));
  };

  const handleBlur = index => {
    const updatedItems = [...itemsAll];
    updatedItems[index].product = branches[selectedBranch ? selectedBranch : 0].products[productIndex];
    if (quantity && quantity > 0) {
      updatedItems[index].quantity = quantity === null || quantity < 0 ? 0 : quantity;
      setItemsAll(updatedItems);
      setMode({ mode: 'view', index: index });
    }
  };

  const addProducts = products => {
    dispatch({ type: 'ADD_PRODUCT_LOGISTIC', products });
  };

  const addObservation = observation => {
    dispatch({ type: 'ADD_OBSERVATION_LOGISTIC', observation });
  };

  const desktopObservationActive = bringResult => {
    if (bringResult) {
      return desktopObservation;
    } else {
      if (desktopObservation) {
        setDesktopObservation(false);
      } else {
        setDesktopObservation(true);
      }
    }
  };

  function findIndexWithNullPropertyExcluding(arr, excludeIndex) {
    const tempArray = [...arr];
    tempArray.splice(excludeIndex, 1);

    for (let i = 0; i < tempArray.length; i++) {
      const item = tempArray[i];
      if (item.product === null || item.quantity === null) {
        return i;
      }
    }
    return false;
  }

  const getBusinessCaracteristics = () => {

    dispatch({ type: "SET_ORDER_ITEMS", items: [] })
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    api
      .get(`/residential/store/v1/stores/${localStorage.getItem('storeId')}/business-characteristics`,
       parameters
      )
      .then(res => {
        setServicesTypes(res.data.serviceType);
        setBranches(res.data.supplyBranches);
        if(!localStorage.getItem("supplyBranchId")) {
          localStorage.setItem(
            'supplyBranchId',
            res.data.standardSupplyBranchId,
          );
        }
        localStorage.setItem(
          'standardServiceType',
          res.data.standardServiceType,
        );
        setShippingMode(res.data.standardShippingMode);
        addProducts(
          res.data.supplyBranches[selectedBranch ? selectedBranch : 0]
            .products,
        );
        dispatch({ type: 'SET_BUSINESS', business: res.data});
        setLoadBusiness(true);
        setLoadingPage(false);
      })
      .catch(err => {
        defaultErrorHandler(err)
      });
  };

  function defaultErrorHandler (err) {
    console.log('err => ', err);

    const handlers = {
      404: (err) => {
        toast.error('Pedido de Abastecimento não disponível na sua região');
        setLoadingPage(false);
      },
      "-1": (err) => {
          setTimeout(() => {
          toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
          setLoadingPage(false);
          handleHome()
        }, 2000)
      }
    };
    handlers[err.response.status != 404 ? "-1" : err.response.status](err);
  }

  function getPayloadForSearchFinancialAndTaxAndConsultant() {
    try {
      const selectedBranch = logisticReducer.selectedBranch;
      return {
        organizacao: {
          id: parseInt(logisticReducer.business.supplyBranches[selectedBranch].orgId),
          organizacaoInventario: {
            id: parseInt(logisticReducer.business.supplyBranches[selectedBranch].erpId)
          }
        },
        cliente: {
          endereco: {
              siteUseId: logisticReducer?.business ? logisticReducer.business.siteUseId : null,
              addressId: logisticReducer?.business ? logisticReducer.business.addressId : null
          },
          id: logisticReducer.business.customerId
        },
        item: itemsAll.map((product) => {
          if (product.quantity !== null && product.product !== null) {
            return {
              id: parseInt(product.product.id)
            };
          }
          return null;
        }).filter((item) => item !== null)
      }
    } catch (error) {
      console.log("Error in mount payload for search data finance and tax and consulting:", error);
      return {}
    }
  }

  function getPayloadForListPrice(paymentCondition, response) {
    try {
      const selectedBranch = logisticReducer.selectedBranch;
      const mappedData = response.products.map(product => {
        const conditionPayment = Array.isArray(paymentCondition?.CondicaoPagamento?.Ordem?.cliente?.condicaoPagamento)
        ? paymentCondition.CondicaoPagamento?.Ordem?.cliente.condicaoPagamento.find(condition => condition.itens.id === Number(product.productId))
        : paymentCondition.CondicaoPagamento?.Ordem?.cliente.condicaoPagamento;

        return {
          idTipoOrdem: parseInt(product.orderTypeId),
          idCondicaoPagamento: parseInt(conditionPayment ? conditionPayment.id : null),
          listaPrecoItem: {
            itens: {
              item: {
                id: parseInt(product.productId)
              }
            }
            }
        };
        }
      );

      return {
        organizacao: {
          id: parseInt(logisticReducer.business.supplyBranches[selectedBranch].orgId),
          organizacaoInventario: {
              id: parseInt(logisticReducer.business.supplyBranches[selectedBranch].erpId)
          }
        },
        cliente: {
          endereco: {
              siteUseId: logisticReducer?.business ? logisticReducer.business.siteUseId : null,
              addressId: logisticReducer?.business ? logisticReducer.business.addressId : null
          },
          id: logisticReducer.business.customerId,
          listaPreco: mappedData
        }
      }
    } catch (error) {
      console.log("Error in mount payload for search price:", error);
      return {}
    }
  }

  function verifyItensInList(items, priceList) {
    const listPriceItems = Array.isArray(priceList.Ordem.listaPreco)
      ? priceList.Ordem.listaPreco
      : [priceList.Ordem.listaPreco];

    const listPriceItemsIds = new Set(
      listPriceItems.map(item => item.listaPrecoItem.itens.item.id.toString())
    );

    for (const item of items) {
      if (!listPriceItemsIds.has(item.product.id)) {
        return false;
      }
    }

    return true;
  }

  async function getPriceList(paymentCondition, response) {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    const data = getPayloadForListPrice(paymentCondition, response);

    try {
      const res = await api.post(`/finance/financial/v1/price-list`, data, parameters);

      if (res.data.Situacao.codigo === 'OK' && verifyItensInList(itemsAll.filter((item) => item.product !== null), res.data)) {
        setIsPriceListOk(true)
        dispatch({ type: "SET_PRICE_LIST", priceList: res.data });
        setLoadingConfirm(false);
        handleNext();
      } else {
        setIsPriceListOk(false)
        setLoadingConfirm(false);
        toast.error('Preço não disponível para o produto selecionado. Contate o SAP Local para suporte.');
        setModalCountdown(false)
      }
    } catch (err) {
      const erro = err?.response;

      if (erro && erro?.status) {
        const message = err?.response?.data?.message;
        if (message) {
          toast.error(message);
        } else {
          toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
        }
        handleHome()
      } else {
        toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
        handleHome()
      }
    }
  };

  async function getTaxDelivery(props) {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    const data = getPayloadForSearchFinancialAndTaxAndConsultant();

    api
      .post(`/finance/financial/v1/delivery-fees`, data, parameters)
      .then(async (res) => {

        if (res?.data && res?.data?.Situacao?.codigo === 'OK') {

          dispatch({ type: "SET_TAX_DELIVERY", taxDelivery: res.data });

          await getSalesConsultant(props);

        } else {

          toast.error('Não existe taxa de entrega cadastrada para essa filial. Contate o seu consultor para garantir o desconto em seu pedido.');
          handleHome();

        }

      })
      .catch(err => {
        console.log('err => ', err);
        const erro = err?.response;
        if (erro && erro?.status) {
          const message = err?.response?.data?.message;
          if (message) {
            toast.error(message);
          } else {
            toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
          }
          handleHome();
        } else {
          toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
          handleHome();
        }
      });
  };

  async function getSalesConsultant(paymentCondition) {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    const data = getPayloadForSearchFinancialAndTaxAndConsultant();
    api
      .post(`/finance/financial/v1/sales-consultants`, data, parameters)
      .then(async (res) => {
        if (res.data.Situacao.codigo === 'OK') {
          dispatch({ type: "SET_SALES_CONSULTANT", salesConsultant: res.data });
          await renderOrderOrVehicleValidation(paymentCondition);
        } else {
          toast.error('O consultor não está cadastrado para o produto selecionado. Contate o SAP Local para suporte.');
          handleHome();
        }
      })
      .catch(err => {
        console.log('err => ', err);
        const erro = err?.response;
        if (erro && erro?.status) {
          const message = err?.response?.data?.message;
          if (message) {
            toast.error(message);
          } else {
            toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
          }
          handleHome();
        } else {
          toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
          handleHome();
        }
      });
  };

  async function getPaymentCondition() {

    setLoadingConfirm(true);
    setModalCountdown(true)

    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };

    const parameters = {
      method: 'GET',
      headers: header,
    };

    const response = getPayloadForSearchFinancialAndTaxAndConsultant();

    try {

      const { data } = await api.post(`/finance/financial/v1/payment-conditions`, response, parameters)

      if (data.Situacao.codigo === 'OK') {
        if (!checkIfAllIdsAreEqual(data)) {
            toast.error('Não é possível criar o pedido com essa configuração. O pedido deve possuir vasilhames com a mesma condição de pagamento');
            setLoadingConfirm(false);
          } else {
            dispatch({ type: "SET_PAYMENT_CONDITION", paymentCondition: data });
            await getTaxDelivery(data);
        }
      } else {
        toast.error('A condição de pagamento não está cadastrada para o produto selecionado. Contate o SAP Local para suporte.');
        handleHome();
      }

      return data

    } catch (err) {
      console.log('err => ', err);
      const erro = err?.response;
      if (erro && erro?.status) {
        const message = err?.response?.data?.message;
        if (message) {
          toast.error(message);
        } else {
          toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
        }
        handleHome();
      } else {
        toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
        handleHome();
      }
    }
  };

  function checkIfAllIdsAreEqual(response) {
    const condicaoPagamento = response.CondicaoPagamento.Ordem.cliente.condicaoPagamento;

    if (condicaoPagamento) {
      if (Array.isArray(condicaoPagamento)) {
        if (condicaoPagamento.length > 0) {
          const ids = condicaoPagamento.map(item => item.id);
          const areAllIdsEqual = ids.every(id => id === ids[0]);
          return areAllIdsEqual ? true : false;
        }
      } else {
        return true;
      }
    }
    return false;
  }

  let transportData = {}

  async function createOrder(paymentCondition) {

    setLoadingConfirm(true);
    setModalCountdown(true)
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };

    const storeId = localStorage.getItem('storeId');
    const supplyBrancheId = logisticReducer.business.supplyBranches[ logisticReducer.selectedBranch ].id;
    const date = logisticReducer.date;
    const products = [];

    itemsAll.map(product => {
      if (product.quantity !== null && product.quantity > 0) {
        products.push({
          productId: product.product.id,
          quantity: product.quantity,
        });
      }
    });

    let body = {};
    const dateOrder = reformatDateString(date);
    const deliveryType = logisticReducer.deliveryType === 'RETIRA' ? 'RETIRA' : 'ENTREGA';
    if (observation !== 'Nenhuma observação') {
      if (observation !== '') {
        body = {
          orderOrigin: "MAP",
          storeId: storeId,
          supplyBrancheId,
          serviceType: deliveryType,
          freightType: logisticReducer.business.standardShippingModeId,
          orderType: 'PEDIDO DE GÁS ENVASADO',
          deliveryDate: dateOrder,
          requireDate: dateOrder,
          orderCreationDateTime: new Date(),
          products,
          notes: observation,
        };
      } else {
        body = {
          orderOrigin: "MAP",
          storeId: storeId,
          supplyBrancheId,
          serviceType: deliveryType,
          freightType: logisticReducer.business.standardShippingModeId,
          orderType: 'PEDIDO DE GÁS ENVASADO',
          deliveryDate: dateOrder,
          requireDate: dateOrder,
          orderCreationDateTime: new Date(),
          products,
        };
      }
    } else {
      body = {
        orderOrigin: "MAP",
        storeId: storeId,
        supplyBrancheId,
        serviceType: deliveryType,
        freightType: logisticReducer.business.standardShippingModeId,
        orderType: 'PEDIDO DE GÁS ENVASADO',
        deliveryDate: dateOrder,
        requireDate: dateOrder,
        orderCreationDateTime: new Date(),
        products,
      };
    }

    const parameters = {
      method: 'POST',
      headers: header,
    };

    try {

      const response = await api.post('/sales/order/v2/orders-ga', body, parameters)

      dispatch({
        type: 'SET_VEHICLE_DATA',
        vehicleData: response.data
      });

      transportData = response.data.sourcedfleet ? response.data.sourcedfleet : response.data.ownfleet

      dispatch({
        type: 'SET_ORDER_DRAFT',
        orderDraftData: { response: response.data, payload: body, data: itemsAll, applied: true }
      });

      dispatch({
        type: 'SET_PREVIOUS_PAGE',
        previousPage: '/criar-pedido'
      });

      await getPriceList(paymentCondition, response.data)

      return response


    } catch (err) {
      console.log('err => ', err.response);
      setLoadingConfirm(false);
      setModalCountdown(false)
      let displayToast = false;
      const responseMessage = err.response.data.message;
      if (responseMessage) {

      if (responseMessage && responseMessage?.includes("Devido ao reajuste de preço programado, inserir o pedido em")) {
          setModalCountdown(false)
          handleHome()
      }

      if (responseMessage && responseMessage?.includes("Não é possível gerar pedido para esta data - selecionar a data")) {
          displayToast = true;
          toast.error(responseMessage);
          setModalCountdown(false)
      } else {
        const extractedDate = extractDateFromMessage(responseMessage);
        dispatch({ type: "ADD_DATE", date:  extractedDate ? extractedDate : '' });
      }

    }

      const errorsForDisplayApi = [
        "Não foi possível efetuar o cancelamento do pedido. Favor entrar em contato com a logística da filial",
        "A data informada ultrapassa o prazo para gerar pedido com antecedência. Prazo: {number} dias",
        "A filial abastecedora não trabalha neste dia da semana",
        "A data informada é um feriado, favor informar um dia útil.",
        "O horário de atendimento da revenda para pedidos nesta data foi excedido."
      ]
      const errosDefined = {
        "A filial abastecedora não possui um calendário de trabalho cadastrado": "Não é possível criar solicitação de abastecimento. Favor acionar o suporte para efetuar os devidos ajustes em seu cadastro com a Ultragaz.",
        "A quantidade solicitada no pedido excede o volume permitido.Volume total solicitado: {number} kg. Volume total permitido: {number} kg.": "Quantidade acima do permitido"
      }

      const errorDefault = responseMessage;

      const message = hasNumberInString(err.response.data.message) ? replaceNumberInString(err.response.data.message, "{number}") : err.response.data.message;

      if (err.response.status === 422) {
        displayToast = true;
        toast.error( 'Não foi possível prosseguir com o pedido. Erro de inconsistência no cadastro. Verifique as informações com a logística e tente novamente.');
        return;
      }

      if (err.response.status !== 502 && err.response.status !== 504) {
        for (const error of errorsForDisplayApi){
          if (message.includes(error)) {
            if (message === error) {
              displayToast = true;
              toast.error(err.response.data.message);
            } else {
              if (!displayToast){
                const messagesSplitedDisplay = err.response.data.message.split(';')
                if (messagesSplitedDisplay.length <= 2) {
                  displayToast = true;
                  toast.error(messagesSplitedDisplay[0]);
                } else {
                  displayToast = true;
                  toast.error(messagesSplitedDisplay[0]);
                  toast.error(messagesSplitedDisplay[messagesSplitedDisplay.length -1]);
                }
              }
            }
          }
        }
        for (const key in errosDefined) {
          if (message.includes(key)) {
            if (message === key) {
              displayToast = true;
              toast.error(errosDefined[key]);
            } else {
              const messagesSplitedDefined = message.split(';')
              if (messagesSplitedDefined.length <= 2) {
                if (messagesSplitedDefined[0] === key) {
                  displayToast = true;
                  toast.error(errosDefined[key]);
                }
              } else {
                if (messagesSplitedDefined[0] === key) {
                  displayToast = true;
                  toast.error(errosDefined[key]);
                }
                if (messagesSplitedDefined[messagesSplitedDefined.length -1] === key) {
                  displayToast = true;
                  toast.error(errosDefined[key]);
                }
              }
            }
          }
        }
        if (!displayToast) {
          toast.error(errorDefault);
        }
      } else {
        toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
        handleHome()
      }

    }

  };

  async function renderOrderOrVehicleValidation(paymentCondition) {

      setLoadingConfirm(true);
      setModalCountdown(true)
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token'),
      };

      const parameters = {
        method: 'GET',
        headers: header,
      };

      const customerId = logisticReducer?.business ? logisticReducer.business.customerId : null;
      const siteUseId = logisticReducer?.business ? logisticReducer.business.siteUseId : null;

      let res = null

      try {
          res = await api.get(`/residential/store/v1/retained-stores?customer_id=${customerId}&site_use_id=${siteUseId}`, parameters);
      } catch (err) {
        // Senhor desenvolvedor:
        // A API acima não possui tratamento de erros, pois mesmo em caso de falhas, o processamento do pedido continuará sem interrupções.
        console.log('err =>', err);
      }

      if (res && res.data.hold === 'Y') {
          toast.error('Identificamos a necessidade de atualizações em seu cadastro, contate o seu consultor para regularização.');
          toast.error(res.data.message);
          setLoadingConfirm(false);
          handleHome()
      } else {
          const itemVerified = itemsAll.filter(item => item.quantity !== null && item.quantity > 0);
          dispatch({
            type: 'SET_ORDER_ITEMS',
            items: itemVerified
          });
          if (deliveryType === mapperServiceType.ENTREGA) {
              await createOrder(paymentCondition);
          } else if (transportData) {
            const response = await createOrder(paymentCondition);
            if (response && response.status === 201 && isPriceListOk) {
              history.push('/vasilhames-subsidiados');
            }
            } else {
              await createOrder(paymentCondition);
          }
      }
  }

  useEffect(() => {
    getBusinessCaracteristics();
  }, [selectedBranch]);

  function verifyProducts() {
    return itemsAll.find((item) => item.quantity !== null) && itemsAll.find((item) => item.product !== null)
  }

  const verifyDateValue = () => {
    if (date !== '') {
      return true;
    }
    return false;
  }

  function handleHome() {
    history.push('/portal');
  }

  function handleNext() {
    history.push('/vasilhames-subsidiados')
  }

  const CustomSelect = React.forwardRef(({ children, onClick }, ref) => {
    return (
      <SelectProduct
        ref={ref}
        onClick={event => {
          event.preventDefault();
          onClick(event);
          expand ? setExpand(false) : setExpand(true);
        }}
      >
        <IconProduct productName={children} />
        <span style={{ marginLeft: '.5rem', fontSize: '0.95rem' }}>{children}</span>
        {expand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </SelectProduct>
    );
  });

  const hasQuantityZeroOrNull = itemsAll.length === 0 || itemsAll.some(item => item.quantity === 0 || item.quantity === null) || quantity === 0

  return (
    <Container>
      <IconsTop>
        <div />
        <IconStyled
          src={close}
          alt="Ícone de fechar"
          onClick={() => setModalCancel(true)}
        />
      </IconsTop>
      <RedirectToPortal
        modalRedirect={modalCancel}
        setModalRedirect={setModalCancel}
      />
      {verifyRoles(roles, 'PEDIDO_DE_ABASTECIMENTO') ? (
          loadingPage ? (
            <Loading loadingColor={'white'} />
          ) : (
            <>
            <CardOrder>
              <MainContainer>
                <Title>
                  <span>Informações Iniciais</span>
                </Title>
                <Stepper activeStep={1} steps={7} />
                <OrderType
                  servicesTypes={servicesTypes}
                  filiais={branches}
                  setSelectedBranch={setSelectedBranch}
                  setSelectedTypes={setDeliveryType}
                  isFrotaPropria={true}
                  shippingMode={shippingMode}
                  setLoadingConfirm={setLoadingConfirm}
                  loadingConfirm={loadingConfirm}
                />
                {loadingItems && (
                  <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                )}
                {!loadingItems && verifyDateValue() && itemsAll.map((item, index) => (
                  <div key={index} style={{ marginBottom: '1.5rem' }}>
                    <Card.Header  style={CardHeader}>
                      Item {index + 1}
                      <DeleteIcon onClick={() => handleDeleteItem(index)} />
                    </Card.Header>
                    <Card style={{ borderTopLeftRadius: '0px', borderTopRightRadius: '0px', boxShadow: '0px 2px 4px #00000033' }}>
                     <Card.Body>
                        {mode.index === index && mode.mode === 'edit' ? (
                          <Row>
                            <Col sm={4}>
                              <Dropdown className="products">
                                <Dropdown.Toggle
                                  as={CustomSelect}
                                  id="dropdown-custom-components"
                                >
                                  {branches[
                                    selectedBranch ? selectedBranch : 0
                                  ].products[productIndex].name ||item.product && item.product.name }
                                </Dropdown.Toggle>

                                <Dropdown.Menu style={{ width: '100%', maxHeight: '200px', overflowY: 'auto'  }}>
                                  {branches[selectedBranch ? selectedBranch : 0].products.map((element, index) => (
                                    <Dropdown.Item
                                      key={element.code}
                                      eventKey={`${element.code}`}
                                      onClick={() => {
                                        setProductIndex(index);
                                        setQuantity(0);
                                      }}
                                      style={AlignDropdownBranch}
                                    >
                                      <AlignProducts>
                                        <Radio
                                          color="primary"
                                          checked={item.product && item.product.name === element.name}
                                        />
                                        <span className="product" style={{fontSize: "13px"}}>
                                          {element.name}
                                        </span>{' '}
                                        <span className="align-icon">
                                          <IconProduct
                                            productName={element.name}
                                            styles={{
                                              p2: IconProductStyles,
                                              p5: IconProductStyles,
                                              p20: IconProductStyles,
                                              p45: IconProductStyles,
                                              p90: IconProductStyles,
                                              p13: IconProductStyles,
                                            }}
                                          />
                                        </span>
                                      </AlignProducts>
                                    </Dropdown.Item>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown>
                            </Col>
                            <Col sm={8}>
                              <Row>
                                <Col sm={8}>
                                  <TextQuantity>Insira a quantidade</TextQuantity>
                                </Col>
                                <Col sm={4}>
                                  <InputQuantity
                                    type="number"
                                    value={quantity === null || quantity < 0 ? 0 : quantity}
                                    onFocus={() => {
                                      if (quantity === 0) {
                                        setQuantity(0);
                                      }
                                    }}
                                    onChange={event => {
                                      const newValue = parseInt(event.target.value);
                                      if (typeof newValue === 'number') {
                                        setQuantity(newValue);
                                      };
                                      const updatedItems = itemsAll
                                      updatedItems[index].quantity = newValue >= 0 ? newValue : 0;
                                      setItemsAll(updatedItems)
                                      logEvent(analytics, 'logistica_campo_quantidade');
                                    }}
                                    onBlur={() => handleBlur(index)}
                                  />
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        ) : (
                          <Row className="flex-wrap align-items-center" >
                            <Col>
                              <Product>
                                <IconProduct
                                  productName={item?.product?.name}
                                  styles={{
                                    p2: { margin: "0 .5rem 0rem 0", width: "10%" },
                                    p5: { margin: "0 .5rem 0rem 0", width: "10%" },
                                    p20: { margin: "0 .5rem 0rem 0", width: "6%" },
                                    p45: { margin: "0 .5rem 0rem 0", width: "6%" },
                                    p90: { margin: "0 .5rem 0rem 0", width: "6%" },
                                    p13: { margin: "0 .5rem 0rem 0", width: "10%" },
                                  }}
                                />
                               {item?.product?.name}
                              </Product>
                            </Col>
                            <Col className="ml-auto">
                              <Quantity>Qtd: {item.quantity}</Quantity>
                            </Col>
                            <Col style={{ maxWidth: '20%' }}>
                              <QuantityIcon>
                                <EditIcon
                                 onClick={() => {
                                  handleEditItem(index);
                                  logEvent(analytics, 'logistica_botao_editar_produto');
                                }}
                                />
                              </QuantityIcon>
                            </Col>
                          </Row>
                        )}
                      </Card.Body>
                    </Card>
                  </div>
                ))}
                {verifyDateValue() ? (
                  <ContainerButton>
                    <ButtonOutline
                      style={{ height: '2.5rem' }}
                      outline
                      onClick={() => {
                        handleAddItem();
                        logEvent(analytics, 'logistica_botao_adicionar_mais_items');
                      }}
                    >
                      <div>+ Adicionar Mais Itens</div>
                    </ButtonOutline>
                  </ContainerButton>
                ) : null}
                <ObservationComponent
                  desktopObservationActive={desktopObservationActive}
                  addObservation={addObservation}
                  observation={observation}
                  date={date}
                />
                <ButtonDivision>
                {hasQuantityZeroOrNull ? (
                    <InfoButtonDisabled
                      style={{ margin: "-1rem 0 0rem 0" }}
                      disabled={!verifyProducts()}
                      onClick={() => {
                        logEvent(analytics, 'logistica_botao_prosseguir_desabilitado');
                      }}
                    >
                      {loadingConfirm ? (
                        <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                      ) : (
                        <div>Prosseguir</div>
                      )}
                    </InfoButtonDisabled>
                  ) : (
                    <InfoButton
                      onClick={() => {
                        getPaymentCondition();
                        logEvent(analytics, 'logistica_botao_prosseguir');
                      }}
                      style={{ margin: "-1rem 0 0rem 0" }}
                    >
                      {loadingConfirm ? (
                        <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                      ) : (
                        <div>Prosseguir</div>
                      )}
                    </InfoButton>
                  )}
                </ButtonDivision>
              </MainContainer>
            </CardOrder>
            <ModalCountdown
              modalCountdown={modalCountdown}
              setModalCountdown={setModalCountdown}
            />
          </>
        )
      ) : (
        <Redirect to="/portal" />
      )}
      <OpenChatBot backgroundColor={'#00f3ff'} />
    </Container>
  );
}
